export default __webpack_public_path__ + "static/media/mdcc.ea159670.svg";